// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__1Fn1_"};